/* PlanningPage Constants */
export const NAVBAR_HEIGHT = 120;
export const COURSE_LIST_WIDTH = 260;
export const SCHEDULE_FIELD_WIDTH = 820;
export const SCHEDULE_FIELD_HEIGHT = 635;
export const SCROLL_BAR_WIDTH = 17;
export const MIN_MARGIN = 30;
export const MIN_WINDOW_WIDTH = 2 * COURSE_LIST_WIDTH + SCHEDULE_FIELD_WIDTH + 2 * MIN_MARGIN;
export const MIN_WINDOW_HEIGHT = NAVBAR_HEIGHT + SCHEDULE_FIELD_HEIGHT + 2 * MIN_MARGIN;
export const SCHEDULE_FIELD_YEAR_WIDTH = 40;
export const SCHEDULE_FIELD_UNIT_WIDTH = 80;
export const PLAN_PANEL_WIDTH = 660;
export const QUARTER_SIZE = 150;

/* Course Panel Constants */
export const SEARCH_BAR_HEIGHT = 40;
export const COURSE_BLOCK_WIDTH = 240;
export const COURSE_BLOCK_HEIGHT = 60;
export const COURSE_LABEL_WIDTH = 110;
export const COURSE_LABEL_HEIGHT = 25;
export const COURSE_FONT_SIZE = 14;
export const COURSE_FONT_INDENT = 10;
export const LIST_TITLE_HEIGHT = 60;